import { render, staticRenderFns } from "./Playlist.vue?vue&type=template&id=cc53ce48&"
import script from "./Playlist.vue?vue&type=script&lang=js&"
export * from "./Playlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/production/spf-sexosafe-ezplatform/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cc53ce48')) {
      api.createRecord('cc53ce48', component.options)
    } else {
      api.reload('cc53ce48', component.options)
    }
    module.hot.accept("./Playlist.vue?vue&type=template&id=cc53ce48&", function () {
      api.rerender('cc53ce48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/SPFPlayer/lib/Playlist.vue"
export default component.exports